"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TellimerGraphqlClient", {
    enumerable: true,
    get: function() {
        return TellimerGraphqlClient;
    }
});
var _urql = require("urql");
var _devtools = require("@urql/devtools");
var _auth = require("./auth");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var isServerSide = typeof window === "undefined";
var ssr = (0, _urql.ssrExchange)({
    isClient: !isServerSide,
    initialState: !isServerSide ? window.__URQL_DATA__ : undefined
});
var TellimerGraphqlClient = /*#__PURE__*/ function() {
    "use strict";
    function TellimerGraphqlClient(baseUrl, apiKey, extraHeaders, requestPolicy, authCallbacks) {
        _classCallCheck(this, TellimerGraphqlClient);
        if (!baseUrl) {
            throw new Error("baseUrl is missing!");
        }
        this.apiKey = apiKey;
        this.baseUrl = baseUrl;
        this.headers = extraHeaders;
        this.requestPolicy = requestPolicy || "cache-and-network";
        this.authCallbacks = authCallbacks;
    }
    _createClass(TellimerGraphqlClient, [
        {
            key: "publicClient",
            get: function get() {
                return (0, _urql.createClient)({
                    url: this.baseUrl,
                    fetchOptions: {
                        headers: _objectSpread({
                            "content-type": "application/json",
                            "x-api-key": this.apiKey
                        }, this.headers)
                    },
                    requestPolicy: this.requestPolicy,
                    exchanges: [
                        _devtools.devtoolsExchange,
                        _urql.dedupExchange,
                        _urql.fetchExchange
                    ]
                });
            }
        },
        {
            key: "privateClient",
            get: function get() {
                var fetchOptions = {
                    headers: _objectSpread({
                        "content-type": "application/json"
                    }, this.headers)
                };
                return (0, _urql.createClient)({
                    url: this.baseUrl,
                    fetchOptions: fetchOptions,
                    requestPolicy: this.requestPolicy,
                    exchanges: [
                        _devtools.devtoolsExchange,
                        _urql.dedupExchange,
                        ssr,
                        (0, _auth.createAuthExchange)(this.authCallbacks),
                        _urql.fetchExchange
                    ]
                });
            }
        }
    ]);
    return TellimerGraphqlClient;
}();

//# sourceMappingURL=index.js.map